module.exports = __webpack_public_path__ + "static/media/2.a781f258.png";